import {Component, OnDestroy, OnInit} from '@angular/core';
import { IDialogView } from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import { DialogModel } from '@shared/models/dialog.model';
import {PrepareImportFieldSectionsCommand} from '../../commands/survey.commands';
import {CommandService} from '@core/services/command.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import { Configuration } from '@shared/models/configuration';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';

@Component({
    standalone: false,
    selector: 'particle-import-field-sections',
  templateUrl: './import-field-sections.component.html',
  styleUrls: ['./import-field-sections.component.scss']
})
export class ImportFieldSectionsComponent implements OnInit, OnDestroy, IDialogView {
  data: DialogModel;
  surveyId: string;
  sourceKey: string;
  invalidateSubject: InvalidateSubject;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  constructor(private commandService: CommandService) {
    this.sourceKey = 'DataSurveyFieldSectionChoice';
    this.invalidateSubject = new InvalidateSubject();
  }

  ngOnInit() {
    if (this.data && this.data.input && this.data.input.surveyId) {
      this.surveyId = this.data.input.surveyId;
      const config = Configuration.getSmartGridConfig('DataSurveyFieldSectionChoice');
          config.Parameters['EXECUTION_ID'] = this.surveyId;
      const prepareImportFieldSectionsCommand = new PrepareImportFieldSectionsCommand(this.surveyId, 'datasurveyconfig');
      this.commandService.executeCommand(prepareImportFieldSectionsCommand)
        .pipe(takeUntil(this.ngUnsubscribe)).subscribe(commandState => {
          this.invalidateSubject.invalidate();
      });
    }
  }
  onOkClicked(): boolean {
    return true;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  onGridCellValueChange($event) {
  }
}
